module.exports = __webpack_public_path__ + "img/revenge.5a007b46.jpg";